import React from 'react'

import ISalary from './salary.interface'
const Salary: React.FC<ISalary> = ({ data }) => {
  const tableCells = [
    {
      name: 'year',
      value: data.year,
    },
    {
      name: 'guaranteedAmount',
      value: Math.round(data.guaranteedAmount),
    },
  ]

  return data ? (
    <tr className="tbody-tr-blue">
      {tableCells.map((cell, index) => {
        return (
          <td key={index} className="td w-1/2">
            <p className="table-text">{cell.value}</p>
          </td>
        )
      })}
    </tr>
  ) : null
}

export default Salary
